import React from 'react';
import sunImage from 'images/sun.svg';
import './Complete.styl';

export default class Complete extends React.Component {
  render() {
    const {model: coachingPlan, sessionUser} = this.props;

    const recipientName = coachingPlan.recipient.info.getFullName();
    const coachName =
      coachingPlan.coach.id === sessionUser.id
        ? 'you'
        : (coachingPlan.coach.info && coachingPlan.coach.info.getFullName()) || 'the coach';

    return (
      <div className="coaching-plan-wizard-complete">
        <header>
          <img alt="sun" src={sunImage} />
          <h2>
            <div>Good job!</div> <div>We've created your coaching plan.</div>
          </h2>
        </header>
        <p>
          {`Calendar invites have been sent to ${coachName} and ${recipientName}. In the Coaching tab in
          Coach you'll find a reminder of upcoming review actions that need to be performed for
          this coaching plan. As
          ${' ' + coachName} and ${recipientName} work through the process, Coach will track and
          graph scores over each review session, so that the coach can see the effectiveness of this
          program. Coach will hold the rep accountable to the requirement.`}
        </p>
        <p>
          If you want to change anything about the plan, you can do this from the Coaching tab in
          the future.
        </p>
      </div>
    );
  }
}
